import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PositionData } from '../model/position-data';
import { HR_CORE_POS_ROUTE_CONFIG, HrCardRouteConfig } from '../model/hr-card-route-config';

@Injectable({
    providedIn: 'root',
})
export class SelectedPositionService{
    positionData=null;
    private sourcePosition = new BehaviorSubject<PositionData>(this.positionData);
    dataPosition$ = this.sourcePosition.asObservable();
    public positionDataOnChange = new BehaviorSubject<number>(this.positionData);
    positionDataChange$ = this.positionDataOnChange.asObservable();
    private _routeConfig: HrCardRouteConfig = HR_CORE_POS_ROUTE_CONFIG;
    private sourceRouteConfig = new BehaviorSubject<HrCardRouteConfig>(this._routeConfig);
    routeConfig$ = this.sourceRouteConfig.asObservable();

    public saveData(data:PositionData) {
        this.positionData = data;
        this.sourcePosition.next(this.positionData);
    }

    public clearData() {
        this.positionData = null;
        this.sourcePosition.next(null);
    }

    public changeRouteConfig(hrCardRouteConfig: HrCardRouteConfig) {
        this._routeConfig = hrCardRouteConfig;
        this.sourceRouteConfig.next(hrCardRouteConfig);
    }

    public getRouteConfig(): HrCardRouteConfig {
        return this._routeConfig;
    }
}
